import "core-js/stable";
import "regenerator-runtime/runtime";


export function loadPolyfills() {
    const fillIntl = () =>
        new Promise(resolve => {
            if (window.Intl) {
                return resolve();
            }

            require.ensure(
                ['intl', 'intl/locale-data/jsonp/en.js'],
                () => {
                    require('intl');
                    
                    require('intl/locale-data/jsonp/en.js');
                    resolve();
                },
                'Intl'
            );
        }).catch(error => {
            console.error(error);
        });

    const fillUrlSearchParms = () =>
        new Promise(resolve => {
            if (window.URLSearchParams) return resolve();

            require.ensure(
                ['@ungap/url-search-params'],
                () => {
                    window.URLSearchParams = require('@ungap/url-search-params');
                    return resolve();
                },
                'URLSearchParams'
            );
        }).catch(error => {
            console.error(error);
        });

    const fillRequestAnimationFrame = () =>
        new Promise(resolve => {
            if (window.requestAnimationFrame) return resolve();

            require.ensure(
                ['raf'],
                () => {
                    window.requestAnimationFrame = require('raf').polyfill();
                    resolve();
                },
                'requestAnimationFrame'
            );
        }).catch(error => {
            console.error(error);
        });

    const fillPluralRules = () =>
        new Promise(resolve => {
            if (window.Intl.PluralRules) return resolve();

            require.ensure(
                ['@formatjs/intl-pluralrules/polyfill', '@formatjs/intl-pluralrules/locale-data/en'],
                () => {
                    require('@formatjs/intl-pluralrules/polyfill');
                    require('@formatjs/intl-pluralrules/locale-data/en');
                    resolve();
                },
                'pluralRules'
            );
        }).catch(error => {
            console.error(error);
        });

    const fillCustomEvent = () =>
        new Promise(resolve => {
            if (typeof window.CustomEvent === 'function') return resolve();

            require.ensure(
                ['custom-event-polyfill'],
                () => {
                    require('custom-event-polyfill');
                    resolve();
                },
                'customEvent'
            );
        }).catch(error => {
            console.error(error);
        });

    return Promise.all([
        fillIntl(),
        fillUrlSearchParms(),
        fillRequestAnimationFrame(),
        fillPluralRules(),
        fillCustomEvent()
    ]);
}
